/**
 * SINGLE SOURCE for the test-status list + status colors. Previously
 * duplicated as local const maps in TestsListingPage and DashboardPage
 * (PIPELINE_COLORS) — both now import from here.
 */
export const TEST_STATUSES = [
  'Scheduled',
  'In Progress',
  'Test Completed',
  'Request Review',
  'Review Completed',
  'Approved',
  // BUG-2026-0190: terminal 'Rejected' status (mirrors the sample 'Rejected'
  // status) — a test that was rejected and will not proceed. Not part of the
  // signoff chain.
  'Rejected',
] as const;

export type TestStatusName = typeof TEST_STATUSES[number];

export const TEST_STATUS_COLORS: Record<string, string> = {
  Scheduled: '#FFC107',
  'In Progress': '#2196F3',
  'Test Completed': '#FF9800',
  'Request Review': '#9C27B0',
  'Review Completed': '#673AB7',
  Approved: '#4CAF50',
  // Red — same semantics as a rejected quote/sample (theme.error family).
  Rejected: '#C62828',
};
